<template>
  <div id="app-englobe">
    <AppTopMenu />
    <div id="app-below-topmenu">
      <SideMenu />
      <main>
        <div id="app-body">
          <div data-product-tour="step-1" />
          <RouterView :key="$route.fullPath" />
        </div>
      </main>
    </div>
  </div>
  <FreemiumUpgradePopup
    title="Souscrire à l'abonnement Essentiel"
    ref="freemiumUpgradePopup"
    closable
    imgUrl="/images/paywall-preview-create-dashboard.png"
  >
    <div class="text-centered">
      <h4 class="title-medium-semibold">Enregistrement de veilles</h4>
      <p>
        Créez des veilles personnalisées sur base des filtres des votre choix.
      </p>
    </div>
  </FreemiumUpgradePopup>
</template>

<script setup lang="ts">
import SideMenu from "@follaw-fr/components/sidemenu/organisms/SideMenu.vue";
import AppTopMenu from "@follaw-fr/components/general/organisms/AppTopMenu.vue";
import FreemiumUpgradePopup from "@follaw-fr/components/reusable/atoms/FreemiumUpgradePopup.vue";
import { provide, ref } from "vue";
import { openDashboardPaywallModalKey } from "@follaw-fr/constants/injection-keys";

const freemiumUpgradePopup = ref<typeof FreemiumUpgradePopup>();

const openDashboardPaywallModal = () => {
  freemiumUpgradePopup.value?.open();
};
provide(openDashboardPaywallModalKey, openDashboardPaywallModal);
</script>

<style lang="scss">
// Global shared styles

:root {
  --color-for: var(--clr-g500);
  --color-against: var(--clr-e400);
  --color-abstention: var(--clr-n7);

  --color-amendments: var(--clr-service-amendment);
  --color-questions: var(--clr-service-question);
  --color-laws: var(--clr-service-legidoc);
  --color-tweets: var(--clr-service-twitter);
  --color-articles: var(--clr-service-article);
  --color-legidocs: var(--clr-service-legidoc);
  --color-reports: var(--clr-service-report);
}

.active-color-amendments {
  --active-color: var(--color-amendments);
}

.active-color-questions {
  --active-color: var(--color-questions);
}

.active-color-laws {
  --active-color: var(--color-laws);
}

.active-color-reports {
  --active-color: var(--color-reports);
}
</style>
